<template>
  <div class="mp">
    <header class="mp-hd">
      <div class="mp-logo">W</div>
      <div>
        <h1 class="mp-title">WordCloudStudio</h1>
        <p class="mp-sub">{{ $t('PremiumUpgrade') }}</p>
      </div>
    </header>

    <div class="mp-plans">
      <label v-for="plan in plans" :key="plan.id" :class="['mp-plan', { 'mp-plan--sel': selected === plan.id }]">
        <input type="radio" :value="plan.id" v-model="selected" class="mp-plan-radio" />
        <span class="mp-plan-body">
          <span class="mp-plan-top">
            <span class="mp-plan-name">{{ $t(plan.title) }}</span>
            <span v-if="plan.recommended" class="mp-plan-badge">{{ $t('Recommended') }}</span>
            <span class="mp-plan-price"><strong>{{ plan.price }}</strong><small>/ {{ $t(plan.time) }}</small></span>
          </span>
          <span class="mp-plan-feats">
            <span v-for="f in plan.features" :key="f" class="mp-plan-feat">
              <svg viewBox="0 0 20 20" fill="currentColor" width="12" height="12"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/></svg>
              {{ $t(f) }}
            </span>
          </span>
        </span>
      </label>
    </div>

    <!-- Subscribe CTA -->
    <a :href="selectedPlanUrl" target="_blank" class="mp-btn mp-btn--cta">
      {{ $t('SubscribeNow') }}
    </a>
    <p class="mp-secure">
      <svg viewBox="0 0 20 20" fill="currentColor" width="12" height="12"><path fill-rule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clip-rule="evenodd"/></svg>
      {{ $t('SecurePaddleCheckout') }}
    </p>

    <!-- Download App -->
    <div class="mp-section">
      <p class="mp-section-title">{{ $t('DownloadApp') }}</p>
      <div class="mp-download">
        <a href="https://wordcloudstudio.com/wordcloudstudio.apk" target="_blank" class="mp-store mp-store--android">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M6 18c0 .55.45 1 1 1h1v3.5a1.5 1.5 0 003 0V19h2v3.5a1.5 1.5 0 003 0V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48A5.96 5.96 0 0012 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31A5.983 5.983 0 006 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zm5 0h-1V4h1v1z"/></svg>
          <div class="mp-store-text"><span class="mp-store-label">Android</span><span class="mp-store-sub">APK</span></div>
        </a>
        <a href="https://apps.apple.com/app/apple-store/id6504160406?pt=126369107&ct=WordCloudStudo_Web&mt=8" target="_blank" class="mp-store mp-store--ios">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>
          <div class="mp-store-text"><span class="mp-store-label">App Store</span><span class="mp-store-sub">iOS</span></div>
        </a>
      </div>
    </div>

    <!-- Account -->
    <div class="mp-section">
      <div class="mp-account">
        <div v-if="isLoggedIn" class="mp-session">
          <svg viewBox="0 0 20 20" fill="currentColor" width="14" height="14"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/></svg>
          <span>{{ savedEmail }}</span>
          <button class="mp-link" @click="clearSession">{{ $t('Logout') }}</button>
        </div>
        <div v-else>
          <p class="mp-section-title">{{ $t('Account') }}</p>
          <div class="mp-field">
            <input v-model="restoreEmail" type="email" class="mp-input" :placeholder="$t('Enter your purchase email')" />
          </div>
          <button class="mp-btn mp-btn--restore" @click="restorePurchase" :disabled="restoring || !restoreEmail">
            <span v-if="restoring" class="mp-spin"></span>
            {{ restoring ? $t('Restoring purchases...') : $t('Restore') }}
          </button>
        </div>

        <!-- Session timeout -->
        <div class="mp-timeout">
          <div class="flex justify-between text-xs mb-1">
            <span>{{ $t('AutoClearSession') }}</span>
            <span class="font-semibold">{{ timeoutLabel }}</span>
          </div>
          <input type="range" v-model.number="timeout" :min="0" :max="5" :step="1" class="mp-range" @change="onTimeoutChange" />
          <div class="flex justify-between text-[10px] text-gray-400 px-0.5">
            <span>1h</span><span>3h</span><span>6h</span><span>12h</span><span>24h</span><span>∞</span>
          </div>
        </div>
        <p v-if="restoreMsg" class="mp-restore-msg" :class="{ 'text-green-600': restoreOk }">{{ restoreMsg }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobilePricing',
  emits: ['done'],
  data() {
    return {
      selected: 'annual',
      restoreEmail: localStorage.getItem('email') || '',
      restoring: false,
      restoreMsg: '',
      restoreOk: false,
      timeout: parseInt(localStorage.getItem('sessionTimeout') || '1'),
      durations: [1, 3, 6, 12, 24, -1],
      plans: [
        { id: 'annual', price: '$16.99', title: 'AnnualVIP', time: 'AnnualVIPTime', recommended: true, features: ['FeatTemplates','FeatFonts','FeatHD','FeatCustomMask','FeatVideoGif','FeatPriority'] },
        { id: 'monthly', price: '$1.99', title: 'MonthlyVIP', time: 'MonthlyVIPTime', recommended: false, features: ['FeatTemplates','FeatFonts','FeatHD','FeatCustomMask','FeatVideoGif'] },
      ],
    }
  },
  computed: {
    isLoggedIn() {
      const s = localStorage.getItem('purchaseStatus')
      const e = localStorage.getItem('expirationTime')
      return s === 'purchased' && e && new Date(e) > new Date()
    },
    savedEmail() { return localStorage.getItem('email') || '' },
    selectedPlanUrl() {
      const plan = this.plans.find(p => p.id === this.selected)
      const pid = plan?.id === 'annual' ? 'pri_01hv37ntpgqgf0nf4vhkzy6st5' : 'pri_01htq3vq91c18n974hrf84c17q'
      return `https://buy.paddle.com/checkout?price_id=${pid}`
    },
    timeoutLabel() {
      const v = this.durations[this.timeout]
      return v === -1 ? this.$t('Permanent') : v + 'h'
    },
  },
  mounted() { this.checkTimeout(); this.updateActivity() },
  methods: {
    checkTimeout() {
      const d = this.durations[this.timeout]
      if (d === -1) return
      const last = localStorage.getItem('lastActivity')
      if (!last) return
      if ((Date.now() - parseInt(last)) / 3600000 >= d) this.clearSession()
    },
    updateActivity() { localStorage.setItem('lastActivity', Date.now().toString()) },
    onTimeoutChange() { localStorage.setItem('sessionTimeout', this.timeout); this.updateActivity() },
    clearSession() {
      ['purchaseStatus','expirationTime','email','lastActivity'].forEach(k => localStorage.removeItem(k))
      this.restoreEmail = ''; this.restoreMsg = ''; this.restoreOk = false
      this.$emit('done')
    },
    async restorePurchase() {
      this.restoring = true; this.restoreMsg = ''; this.restoreOk = false
      try {
        if (this.restoreEmail) localStorage.setItem('email', this.restoreEmail.trim())
        this.updateActivity()
        const s = localStorage.getItem('purchaseStatus'), e = localStorage.getItem('expirationTime')
        if (s === 'purchased' && e && new Date(e) > new Date()) {
          this.restoreMsg = this.$t('RestoreSuccess'); this.restoreOk = true; this.$emit('done');
        } else {
          this.restoreMsg = this.$t('RestoreNotFound')
        }
      } catch (e) { this.restoreMsg = e.message }
      finally { this.restoring = false }
    },
  },
}
</script>

<style scoped>
.mp { padding: clamp(10px,3vw,16px); padding-bottom: 40px; max-width: 30rem; margin: 0 auto; color: var(--color-text-900); font-size: clamp(13px,3.5vw,15px); line-height: 1.5; }
.mp-hd { display: flex; align-items: center; gap: clamp(8px,2vw,12px); margin-bottom: clamp(10px,2.5vw,16px); }
.mp-logo { width: clamp(36px,10vw,44px); height: clamp(36px,10vw,44px); border-radius: 12px; background: linear-gradient(135deg,var(--color-brand-500),var(--color-brand-700)); display: flex; align-items: center; justify-content: center; color: #fff; font-weight: 700; font-size: clamp(16px,4vw,20px); flex-shrink: 0; }
.mp-title { margin: 0; font-size: clamp(16px,4vw,20px); font-weight: 700; }
.mp-sub { margin: 2px 0 0; font-size: clamp(11px,2.5vw,13px); color: var(--color-text-400); }

.mp-btn { display: inline-flex; align-items: center; justify-content: center; gap: 6px; border: none; border-radius: clamp(10px,2.5vw,14px); font-size: clamp(13px,3.5vw,15px); font-weight: 600; cursor: pointer; min-height: clamp(40px,10vw,48px); padding: 0 20px; text-decoration: none; }
.mp-btn--cta { width: 100%; background: var(--color-brand-600); color: #fff; margin-top: 12px; }
.mp-btn--cta:hover { background: var(--color-brand-700); }
.mp-btn--restore { width: 100%; background: #f59e0b; color: #fff; }
.mp-secure { text-align: center; font-size: clamp(10px,2.5vw,12px); color: var(--color-text-400); margin: 6px 0 0; display: flex; align-items: center; justify-content: center; gap: 4px; }

.mp-plans { display: flex; flex-direction: column; gap: 10px; }
.mp-plan { display: flex; align-items: flex-start; gap: 10px; padding: clamp(12px,3vw,16px); background: var(--color-surface-0,#fff); border: 2px solid var(--color-surface-200); border-radius: clamp(10px,2.5vw,14px); cursor: pointer; transition: all .15s; }
.mp-plan--sel { border-color: var(--color-brand-600); box-shadow: 0 0 0 2px rgba(79,70,229,.15); }
.mp-plan-radio { position: absolute; opacity: 0; }
.mp-plan-body { flex: 1; min-width: 0; }
.mp-plan-top { display: flex; flex-wrap: wrap; align-items: baseline; gap: 6px 10px; }
.mp-plan-name { font-weight: 700; }
.mp-plan-badge { font-size: clamp(9px,2.5vw,10px); font-weight: 600; background: var(--color-brand-600); color: #fff; padding: 1px 8px; border-radius: 999px; }
.mp-plan-price { margin-left: auto; text-align: right; }
.mp-plan-price strong { font-size: clamp(18px,5vw,22px); font-weight: 800; }
.mp-plan-price small { font-size: clamp(11px,2.5vw,13px); color: var(--color-text-400); display: block; }
.mp-plan-feats { display: flex; flex-wrap: wrap; gap: 4px 10px; margin-top: 8px; padding-top: 8px; border-top: 1px solid var(--color-surface-100); }
.mp-plan-feat { display: inline-flex; align-items: center; gap: 3px; font-size: clamp(11px,2.5vw,13px); color: var(--color-text-500); }
.mp-plan-feat svg { color: var(--color-success); flex-shrink: 0; }

/* Section */
.mp-section { margin-top: clamp(12px,3vw,18px); }
.mp-section-title { font-size: clamp(13px,3.5vw,15px); font-weight: 700; margin: 0 0 8px; }

/* Download */
.mp-download { display: flex; gap: 10px; }
.mp-store { flex: 1; display: flex; align-items: center; gap: 10px; padding: 12px 14px; border-radius: clamp(10px,2.5vw,14px); background: var(--color-surface-0,#fff); border: 2px solid var(--color-surface-200); text-decoration: none; transition: all .15s; }
.mp-store--android { border-color: #a4c639; }
.mp-store--android:hover { background: #f7fdf4; }
.mp-store--ios { border-color: #8e8e93; }
.mp-store--ios:hover { background: #fafafa; }
.mp-store-text { display: flex; flex-direction: column; }
.mp-store-label { font-size: clamp(12px,3vw,14px); font-weight: 700; color: var(--color-text-800); }
.mp-store-sub { font-size: clamp(10px,2.5vw,11px); color: var(--color-text-400); }
.mp-store svg { flex-shrink: 0; opacity: .7; }

/* Account */
.mp-account { padding: clamp(12px,3vw,16px); background: var(--color-surface-0,#fff); border-radius: clamp(10px,2.5vw,14px); border: 1px solid var(--color-surface-200); }
.mp-session { display: flex; align-items: center; gap: 6px; padding: 8px 10px; background: #f0fdf4; border-radius: 8px; font-size: clamp(12px,3vw,14px); margin-bottom: 10px; }
.mp-session svg { color: #16a34a; flex-shrink: 0; }
.mp-session span { flex: 1; font-weight: 500; color: #15803d; word-break: break-all; }
.mp-link { background: none; border: none; color: #dc2626; font-size: 11px; font-weight: 600; cursor: pointer; white-space: nowrap; }
.mp-field { margin-bottom: 8px; }
.mp-input { width: 100%; padding: 10px 12px; border: 1px solid var(--color-surface-300); border-radius: 8px; font-size: inherit; background: #fff; outline: none; box-sizing: border-box; }
.mp-input:focus { border-color: var(--color-brand-500); box-shadow: 0 0 0 2px rgba(79,70,229,.15); }
.mp-timeout { margin-top: 14px; padding-top: 12px; border-top: 1px solid var(--color-surface-100); }
.mp-range { width: 100%; -webkit-appearance: none; appearance: none; height: 6px; background: var(--color-surface-200); border-radius: 3px; outline: none; margin: 4px 0; }
.mp-range::-webkit-slider-thumb { -webkit-appearance: none; width: 20px; height: 20px; border-radius: 50%; background: var(--color-brand-600); cursor: pointer; box-shadow: 0 1px 3px rgba(0,0,0,.15); }
.mp-restore-msg { margin-top: 8px; font-size: clamp(11px,2.5vw,13px); color: var(--color-text-500); text-align: center; }
.mp-spin { width: 14px; height: 14px; border: 2px solid rgba(255,255,255,.3); border-top-color: #fff; border-radius: 50%; animation: mp-spin .7s linear infinite; display: inline-block; }
@keyframes mp-spin { to { transform: rotate(360deg); } }
</style>
